import { getPage } from '../content/source.js';
import ContentPage from '../content/ContentPage.jsx';

const page = getPage('help');

export function meta() {
  return [{ title: `${page.title} · WriteUp` }, { name: 'description', content: page.description }];
}

export default function HelpRoute() {
  return <ContentPage page={page} />;
}
